import './OfferCustomForm.scss';
import { useEffect, useState } from 'react';
import { IOffer, IOfferAction } from '@models/winnerSelection/ITableDemand';
import ModalFormBuilder, { IModalFormBuilderProps } from '@molecules/ModalFormBuilder/ModalFormBuilder';
import { IForms } from '@models/Forms/IForms';
import { IFieldElem } from '@models/IFormData';
import { useForm } from 'react-hook-form';
import { IDocumentData } from '@models/document/IDocumentData';
import { convertListToMap } from '@utils/documentUtils';
import { DocumentService } from '@services/DocumentService';
import { WinnerSelectionService } from '@services/WinnerSelectionService';

export interface IOfferCustomFormProps {
    tableKey: string;
    value: IOffer;
    action: IOfferAction;
    onClose?: () => void;
}

const OfferCustomForm = ({ tableKey, value, action, onClose }: IOfferCustomFormProps) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [errorText, setErrorText] = useState<string>();
    const [form, setForm] = useState<IForms>();
    const [fieldsData, setFieldsData] = useState<Record<string, IFieldElem>>();

    const methods = useForm<IDocumentData>({
        mode: 'onBlur', // "onChange"
    });

    useEffect(() => {
        setLoading(true);
        // Получение схемы формы
        const schemeResult = WinnerSelectionService.fetchCustomFormScheme(tableKey, action.key)
            .then((result) => {
                const form = result.data;
                setForm(form);
            })
            .catch((error) => setErrorText(error));

        // Получение данных документа
        const dataResult = DocumentService.getData(value.key)
            .then((result) => {
                if (result.data) {
                    const f = result.data.fields;
                    const fields = convertListToMap(f);
                    setFieldsData(fields);
                    methods.reset(result.data);
                }
            })
            .catch((error) => setErrorText(error));

        Promise.all([schemeResult, dataResult]).then(() => {
            setLoading(false);
        });
    }, []);

    const messageBoxProp: IModalFormBuilderProps = {
        header: action.title,
        showOkButton: false,
        showCancelButton: false,
        onCancel: onClose,
        size: action.modalSize ?? 'xl',
        loading: loading,
        errorText: errorText,
        formMethods: methods,
        fields: fieldsData ?? {},
        changeActions: form?.changeActions,
        rows: form?.view,
        showContent: !!fieldsData,
        docId: value.key,
        isEdit: false,
        isNew: false,
    };

    // Единый ModalFormBuilder на весь цикл: рамка модалки со спиннером-оверлеем
    // видна сразу (loading), контент дозагружается внутри — как у батч-модалок.
    return <ModalFormBuilder {...messageBoxProp} />;
};

export default OfferCustomForm;
